<template>
    <div v-if="paymentMethods && paymentMethods.visa_checkout">
        <div v-if="cardSelected === false">
            <div v-html="$t('_checkout._payment.walletInstructionsHtmlX', ['Visa Checkout'])" />

            <img
                v-if="$scope.IN_PRODUCTION"
                alt="Visa Checkout"
                class="v-button mt pull-right"
                role="button"
                src="https://secure.checkout.visa.com/wallet-services-web/xo/button.png"
            />
            <img
                v-else
                alt="Visa Checkout"
                class="v-button mt pull-right"
                role="button"
                src="https://sandbox.secure.checkout.visa.com/wallet-services-web/xo/button.png"
            />
            <div class="clearfix"></div>
        </div>
        <div v-else>
            <div class="alert d-flex flex-align-center mb">
                <i class="icon-cr icon-ok mr flex-child-fixed"></i>
                <span>{{
                        $t('_checkout._payment.walletCardSuccessfullySelectedX', ['Visa Checkout'])
                    }}</span>
            </div>

            <SelectField
                v-if="paymentMethods"
                v-model="installmentsSelected"
                :error.sync="installmentsError"
                label="Agora selecione o parcelamento:"
            >
                <option :value="null"></option>
                <option v-for="option in paymentMethods.cartoesdecredito" :value="option">
                    {{ option.total_installments }}x {{ $t('of') }}
                    {{ $f.formatMoney(option.installments[0]) }} &nbsp;(Total
                    {{ $f.formatMoney(option.total) }}
                    <template v-if="option.interests > 0">
                        ,
                        {{
                            $t('_checkout._payment._card.interestsMonth', [
                                formatNumber(option.interests, 2),
                            ])
                        }})
                    </template>
                    <template v-else>, {{ $t('_shop.interestFree') }})</template>
                </option>
            </SelectField>
        </div>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';
    import accounting from '../../../../helpers/accounting';
    import SelectField from '../../../../components/input/select-field/SelectField.vue';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentVisaCheckout',

        components: { SelectField },

        props: ['cart', 'customer', 'paymentMethods'],

        data() {
            return {
                cardSelected: false,
                installmentsSelected: undefined,
                walletPayload: undefined,
                installmentsError: null,
            };
        },

        watch: {
            paymentMethods(to) {
                if (to) {
                    this.resetMethod();
                }
            },

            cardSelected: {
                immediate: true,
                handler(to) {
                    this.storeState.payment.visaCheckoutIsReady = to;
                },
            },
        },

        computed: {
            description() {
                if (!this.installmentsSelected) return 'Visa Checkout';

                const installments =
                    (this.installmentsSelected.total_installments || 1) === 1
                        ? this.$t('_shop.inCash')
                        : this.$tc(
                            '_shop.installmentsX',
                            this.installmentsSelected.total_installments || 1
                        );
                return `Visa Checkout - ${installments}`;
            },
        },

        mounted() {
            this.resetMethod();
        },

        methods: {
            formatNumber(value, precision) {
                return accounting.formatNumber(value, precision);
            },

            resetMethod() {
                this.cardSelected = false;
                this.installmentsSelected = undefined;
                this.walletPayload = undefined;

                this.initVisaCheckout();
            },

            initVisaCheckout() {
                if (!window.V) {
                    this.$emit(
                        'error',
                        this.$t('_checkout._payment._errorWalletConnectionTryAgain', [
                            'Visa Checkout',
                        ])
                    );
                    return;
                }

                window.V.init({
                    apikey: this.$scope.checkoutPreferences.visaCheckoutKey,
                    paymentRequest: {
                        currencyCode: 'BRL',
                        subtotal: this.cart.total_products,
                        total: this.cart.total_paid,
                        orderId: this.cart.id.toString(),
                    },
                    settings: {
                        locale: 'pt_BR',
                        displayName: 'Chico Rei',
                        websiteUrl: 'https://chicorei.com',
                        shipping: {
                            collectShipping: false,
                        },
                        dataLevel: 'FULL',
                    },
                });

                window.V.on('payment.success', this.paymentSuccess);
                window.V.on('payment.cancel', this.paymentCanceled);
                window.V.on('payment.error', this.paymentError);
            },

            paymentSuccess(data) {
                this.cardSelected = true;
                this.walletPayload = {
                    callid: data.callid,
                    encKey: data.encKey,
                    encPaymentData: data.encPaymentData,
                };
            },

            paymentCanceled() {
                this.$emit(
                    'error',
                    this.$t('_checkout._payment.errorWalletCancelledX', ['Visa Checkout'])
                );
            },

            paymentError() {
                this.$emit(
                    'error',
                    this.$t('_checkout._payment.errorWalletFailedX', ['Visa Checkout'])
                );
            },

            submit(callback) {
                if (!this.cardSelected) return;

                if (!this.installmentsSelected) {
                    this.installmentsError = this.$t('_checkout._payment._card.selectInstallments');
                    return;
                }

                callback({
                    module: 'cartoesdecredito',
                    installments: this.installmentsSelected.total_installments,
                    wallet: true,
                    walletType: 'visacheckout',
                    walletPayload: this.walletPayload,
                });
            },
        },
    };
</script>
